module.exports = __webpack_public_path__ + "static/media/Terms_Conditions_French.2e1b0f04.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Terms_Conditions_French.pdf
// module id = 1505
// module chunks = 0